import { c as _c } from "react/compiler-runtime";
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { HTTPMethod } from '@/constants/rest';
import { operations } from './generated/selfCare';
type MyContractSupportRequestCreateQueryBody = operations['myContractSupportRequestCreate']['requestBody']['content']['application/json'];
type MyContractSupportRequestCreateQueryResponse = operations['myContractSupportRequestCreate']['responses']['201']['content'] | undefined;
type MutateFunctionType = (data: MyContractSupportRequestCreateQueryBody) => Promise<MyContractSupportRequestCreateQueryResponse>;
export function useMyContractSupportRequestCreateQuery() {
  const $ = _c(1);
  const mutationFunction = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: mutationFunction
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(data) {
  const res = await apiSelfCareFetcher(URLS.myContractSupportRequestCreate, {
    method: HTTPMethod.POST,
    body: data
  });
  return res.json;
}